import Vue from "vue";
import {ActionTree, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {Question, Survey} from "@/store/modules/lib";
import axios from "axios";
import {SERVER_HOST_QR} from "@/config";
import VueI18n from '../../helpers/i18n';


export interface State {
  surveys: any[];
  survey: any;
  stateCurrentSurvey: any;
  loading: string;
}

const defaultState: State = {
  surveys: [],
  survey: [],
  stateCurrentSurvey: [],
  loading: "",
};

const getters = {
  surveys: (state: State) => state.surveys,
  survey: (state: State) => state.survey,
  stateCurrentSurvey: (state: State) => state.stateCurrentSurvey,
  loading: (state: State) => state.loading,
};

const mutations: MutationTree<State> = {
  setLoadStatus(state: State, payload: any) {
    state.loading = payload;
  },
  setSurveys(state: State, payload: any[]) {
    state.surveys = payload 
  },
  setSurvey(state: State, payload: any) {
    payload.survey.isEdit = payload.isEdit
    state.survey = payload.survey
  },
  setCurrentSurvey(state: State, payload: any) {
    state.stateCurrentSurvey = payload
  },
  setUpdateSurveys(state: State, payload: any) {
    let arr = state.surveys.map((el:any)=>
    {
      if(el.survey.id === payload.id){
        payload.questionsCount = el.survey.questionsCount 
        el.survey = payload
        return el
      } else {
        return el
      }
    })
   state.surveys = arr
  }
};

const actions: ActionTree<State, RootState> = {
  async createSurvey({commit, state}, payload: any) {
    try {
      const {data} = await axios.post(SERVER_HOST_QR + 'surveys', payload)
      if (data.error) {
        throw (data.error)
      }
      commit('setSurvey', {survey: {survey: data.data}, isEdit: false})
      console.log(payload)
      if(payload.message) {
        this.commit('alerts/setAlert', {
          show: true,
          color: 'red',
          messages: [payload.message]
        })
      }
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
    }
  },
  async loadSurveysFromServer({commit, state}, payload: any) {
    commit('setLoadStatus', true)
    try {
      const {data} = await axios.get(SERVER_HOST_QR + 'surveys')
      if (data.error) {
        throw (data.error)
      }
      commit('setSurveys', data.data)
      commit('setLoadStatus', false)
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      commit('setLoadStatus', false)
    }
  },
  async loadSurvey({commit, state}, payload: any) {
    commit('setLoadStatus', true)
    try {
      const {data} = await axios.get(SERVER_HOST_QR + 'surveys/' + payload)
      if (data.error) {
        throw (data.error)
      }
      commit('setSurvey', {survey: data.data, isEdit: false})
      commit('setLoadStatus', false)
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      commit('setLoadStatus', false)
    }
  },
  async updateSurvey({commit, state}, payload: any) {
    commit('setLoadStatus', true)
    let id = payload.id
    let params = payload.params
    try {
      const {data} = await axios.patch(SERVER_HOST_QR + 'surveys/' + id, params)
      if (data.error) {
        throw (data.error)
      }
      commit('setSurvey', {survey: {survey: data.data}, isEdit: false})
      commit('setUpdateSurveys', data.data)
      commit('setLoadStatus', false)
      if(payload.message && payload.message.length) {
        this.commit('alerts/setAlert', {
          show: true,
          color: 'red',
          messages: [payload.message]
        })
      } 
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      commit('setLoadStatus', false)
      return e
    }
  },
  showEditAlert({commit, state}, payload: any) {
    this.commit('alerts/setAlert', {
      show: true,
      color: 'red',
      messages: [payload]
    })
  }
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
